"use client";

import { Suspense } from "react";
import DataTabs from "@/components/DataTabs";

export default function DivergencesPage() {
  return (
    <main>
      <Suspense fallback={<div>Loading...</div>}>
        <DataTabs initialTab="divergences" showTabBar={false} />
      </Suspense>
    </main>
  );
}
